import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ReduxState } from '@/redux/modules/types';

export const HtmlLangSync = () => {
  const locale = useSelector((state: ReduxState) => state.intl.locale);

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  return null;
};
